import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import SpecialistRoleSwitcher from "./SpecialistRoleSwitcher";

const DisplayNameAndRole = () => {
  const { t } = useTranslation();
  const { user } = useSelector((state) => state.auth);
  const {
    isAdministrator,
    isSpecialistFeeder,
    isSpecialistPreManager,
    isSpecialistManager,
    isSpecialistValidator,
    isSpecialistEditor,
    isSpecialistCoordinator,
    isSpecialistLiaison,
    isEndUser,
    isEndUserInstitutional,
    isReporter,
    haveMultipleRoles
  } = useSelector((state) => state.userRole.roleLogin);

  const DisplayWelcomeName = () => {
    if (user) {
      return (
        <div style={{ paddingLeft: '20px', paddingRight: '20px', color: 'white' }}>
          <span><strong> {t("general.welcome")}: </strong></span>
          {user.first_name} {user.last_name}
        </div>
      );
    }

    return null;
  };

  const appendRole = (rolesDisplay, roleKey) => {
    if (rolesDisplay) {
      return `${rolesDisplay}, ${t(roleKey)}`;
    }
    return `${t(roleKey)}`;
  };

  const DisplayRoles = () => {
    let rolesDisplay = "";

    if (isAdministrator) {
      rolesDisplay = `${t('roles.administrator')}`;
    }

    if (isSpecialistFeeder) {
      rolesDisplay = appendRole(rolesDisplay, 'roles.specialist-feeder');
    }

    if (isSpecialistPreManager) {
      rolesDisplay = appendRole(rolesDisplay, 'roles.specialist-pre-manager');
    }

    if (isSpecialistManager) {
      rolesDisplay = appendRole(rolesDisplay, 'roles.specialist-manager');
    }

    if (isSpecialistValidator) {
      rolesDisplay = appendRole(rolesDisplay, 'roles.specialist-validator');
    }

    if (isSpecialistEditor) {
      rolesDisplay = appendRole(rolesDisplay, 'roles.specialist-editor');
    }

    if (isSpecialistLiaison) {
      rolesDisplay = appendRole(rolesDisplay, 'roles.specialist-liaison');
    }

    if (isSpecialistCoordinator) {
      rolesDisplay = appendRole(rolesDisplay, 'roles.specialist-coordinator');
    }

    if (isReporter) {
      rolesDisplay = appendRole(rolesDisplay, 'roles.reporter');
    }

    if (isEndUser) {
      rolesDisplay = appendRole(rolesDisplay, 'roles.end-user');
    } else if (isEndUserInstitutional) {
      rolesDisplay = appendRole(rolesDisplay, 'roles.end-user-institutional');
    }

    if (rolesDisplay) {
      return (
        <div style={{ paddingLeft: '20px', paddingRight: '20px', color: 'white' }}>
          <span>
            <strong>
              {haveMultipleRoles ? ` ${t("general.roles")}:` : `${t("general.role")}:`}
            </strong>
          </span>
          {rolesDisplay}
        </div>
      );
    }

    return null;
  };

  return (
    <div className="d-flex flex-wrap align-items-center">
      <DisplayWelcomeName />
      <DisplayRoles />
      <SpecialistRoleSwitcher />
    </div>
  );
};

export default DisplayNameAndRole;
